import React, { ReactNode } from 'react';

import {
  CHALLENGE_SECTION,
  ChallengeSectionKey,
} from '../../../../../constants/challengeSection';

const SECTION_DISPLAY_NAMES: Record<ChallengeSectionKey, string> = {
  [CHALLENGE_SECTION.ABOUT]: 'About',
  [CHALLENGE_SECTION.IMPORTANT_DATES]: 'Important Dates',
  [CHALLENGE_SECTION.PRIZES]: 'Prizes',
  [CHALLENGE_SECTION.FAQ]: 'FAQ',
};

export const getPublishTooltip = (
  invalidSections: ChallengeSectionKey[],
): ReactNode | null => {
  if (invalidSections.length === 0) return null;

  const sectionNames = invalidSections
    .map((key) => `"${SECTION_DISPLAY_NAMES[key]}"`)
    .join(', ');

  return (
    <span>
      Challenge publication is unavailable. <br /> Please fill out the {sectionNames}
    </span>
  );
};
